// We should use ID as the key, not the regulation name
// Refactor this later at some point
export const getChartColor = (label) => {
    switch (label) {
        case "EPA 608": return "#009688";
        case "EPA AIM Act": return "#2E7D32";
        case "CA CARB": return "#EF6C00";
        case "CA SCAQMD": return "#AB4E01";
        case "WA Ecology": return "#2196F3";
        case "NY DEC": return "#9C27B0";
        case "NJ DEP": return "#C2185B";
        default: return "transparent";
    }
}

export const generateVirtualElement = (mousePosition) => {
    if (mousePosition === null) {
        return {
            getBoundingClientRect: () => ({
                width: 0,
                height: 0,
                x: 0,
                y: 0,
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                toJSON: () => '',
            }),
        };
    }
    const { x, y } = mousePosition;
    const boundingBox = {
        width: 0,
        height: 0,
        x,
        y,
        top: y,
        right: x,
        bottom: y,
        left: x,
    };
    return {
        getBoundingClientRect: () => ({
            ...boundingBox,
            toJSON: () => JSON.stringify(boundingBox),
        }),
    };
}